import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://cloudpet.com.ar';
const LOGO_URL = `${SITE_URL}/logo.png`;

export default function SEOHead({ title, description, image, url, type = 'website', structuredData }) {
    const fullTitle = title
        ? `${title} | CloudPet`
        : 'CloudPet - Pet Shop Online en Buenos Aires';
    const desc = description
        || 'Tu tienda online de juguetes, alimentos y accesorios para mascotas. Envios a todo Buenos Aires y alrededores. Los mejores productos para tu perro y gato.';
    const canonicalUrl = url || (typeof window !== 'undefined' ? window.location.href : SITE_URL);
    const ogImage = image
        ? (image.startsWith('http') ? image : `${SITE_URL}${image}`)
        : LOGO_URL;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:type" content={type} />
            <meta property="og:locale" content="es_AR" />
            <meta property="og:site_name" content="CloudPet" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={ogImage} />

            <link rel="icon" type="image/png" href="/logo.png" />

            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
}
